module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/button.json
// module id = 705
// module chunks = 63